/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';

export const selectNotificationPanelOpen    = ({notificationsPanel: {panel: {open}}}) => open;
export const selectUnreadNotificationsCount = ({notificationsPanel: {unreadCount}}) => unreadCount;

export const unreadNotificationsCountSelector = createSelector([selectUnreadNotificationsCount],
  (notificationCount) => (notificationCount));

export const notificationPanelOpenSelector    = createSelector([selectNotificationPanelOpen],
  (open) => (open)
);
